import React from 'react';

import { SubRoutes } from '../../routes';

import ContactListPage from './_list';
import ContactDetailPage from './_detail';

const MainContactPage = () => {
  return <SubRoutes name="contact" />;
};

const Contact = {
  MainContactPage,
  ContactListPage,
  ContactDetailPage,
};

export default Contact;
